export const foodDetails = {
  '北京烤鸭': {
    name: '北京烤鸭',
    nameEn: 'Peking Duck',
    description: '北京烤鸭是北京最著名的传统名菜，被誉为"天下第一美味"。选用优质的北京填鸭，经过果木炭火精心烤制，成品色泽红润，皮脆肉嫩，肥而不腻。',
    history: '北京烤鸭的历史可以追溯到南北朝时期，当时已有"炙鸭"的记载。明代时成为宫廷名菜，清代时逐渐传入民间，形成了挂炉烤鸭和焖炉烤鸭两大流派。全聚德和便宜坊是最著名的两家老字号。',
    ingredients: ['北京填鸭', '荷叶饼', '甜面酱', '葱丝', '黄瓜条', '白糖'],
    taste: '外皮酥脆，肉质鲜嫩，肥而不腻，带有淡淡的果木香气',
    priceRange: '¥188 - ¥688/只',
    recommendedRestaurants: ['全聚德', '便宜坊', '大董', '四季民福'],
    funFacts: [
      '北京烤鸭曾是明清宫廷御膳',
      '一只优质的填鸭需要饲养约45天',
      '正宗的吃法是用荷叶饼卷着吃',
      '全聚德始建于1864年'
    ],
    category: '肉类',
    popularity: 98,
    tags: ['传统名菜', '宫廷菜', '北京必吃']
  },
  
  '炸酱面': {
    name: '炸酱面',
    nameEn: 'Zhajiangmian',
    description: '炸酱面是北京最具代表性的传统面食，由炸酱、面条和丰富的菜码组成。酱料用黄酱和甜面酱炒制五花肉丁，面条劲道，菜码清爽。',
    history: '炸酱面起源于清代，最初是满族的传统食品，后来传入汉族民间。老北京人有"头伏饺子二伏面"的说法，炸酱面是夏季最受欢迎的面食。',
    ingredients: ['手工面条', '五花肉丁', '黄酱', '甜面酱', '黄瓜', '豆芽', '萝卜', '青豆'],
    taste: '酱香浓郁，面条劲道，配菜清爽，咸香适口',
    priceRange: '¥25 - ¥68/碗',
    recommendedRestaurants: ['海碗居', '老北京炸酱面大王', '方砖厂69号'],
    funFacts: [
      '老北京炸酱面的菜码最多可达12种',
      '炸酱要小火慢炒半小时才够香',
      '面条必须是手擀或抻面',
      '吃的时候要拌匀才够味'
    ],
    category: '面食',
    popularity: 92,
    tags: ['传统面食', '家常菜', '老北京味道']
  },
  
  '涮羊肉': {
    name: '涮羊肉',
    nameEn: 'Instant-boiled Mutton',
    description: '涮羊肉是北京冬季最受欢迎的美食，使用特制的铜锅炭火，将薄薄的羊肉片在沸水中快速涮煮，蘸上麻酱调料食用。',
    history: '涮羊肉据说起源于元代，由元世祖忽必烈发明。清代时成为宫廷冬令佳肴，后来传入民间。东来顺是最著名的老字号。',
    ingredients: ['手切羊肉', '铜锅炭火', '麻酱调料', '韭菜花', '腐乳', '糖蒜', '白菜', '粉丝'],
    taste: '羊肉鲜嫩，调料香浓，汤底清淡，暖胃暖心',
    priceRange: '¥128 - ¥398/人',
    recommendedRestaurants: ['东来顺', '南门涮肉', '聚宝源', '阳坊胜利'],
    funFacts: [
      '据说由忽必烈在征战途中发明',
      '正宗的涮羊肉用的是内蒙古苏尼特羊',
      '铜锅导热快，能保持羊肉的鲜嫩',
      '麻酱调料的配比是每家店的秘密'
    ],
    category: '火锅',
    popularity: 90,
    tags: ['冬季美食', '传统火锅', '羊肉']
  },
  
  '豆汁儿': {
    name: '豆汁儿',
    nameEn: 'Fermented Mung Bean Juice',
    description: '豆汁儿是北京最独特的传统小吃，由绿豆发酵制成，颜色灰绿，味道酸馊，初次尝试的人往往难以接受，但老北京人却视为珍馐。',
    history: '豆汁儿的历史可以追溯到辽宋时期，清代时成为宫廷饮品，后来传入民间。老北京人喝豆汁儿要配焦圈和辣咸菜丝。',
    ingredients: ['绿豆', '水', '焦圈', '辣咸菜丝'],
    taste: '酸馊中带着微甜，初次尝试需要勇气，爱上后欲罢不能',
    priceRange: '¥5 - ¥15/碗',
    recommendedRestaurants: ['尹三豆汁', '老磁器口豆汁店', '锦芳小吃'],
    funFacts: [
      '豆汁儿是绿豆发酵后的副产品',
      '乾隆皇帝曾将豆汁儿引入宫廷',
      '老北京人说："不喝豆汁儿，不算北京人"',
      '初次尝试建议配焦圈和咸菜中和酸味'
    ],
    category: '小吃',
    popularity: 75,
    tags: ['传统小吃', '北京特色', '发酵食品']
  },
  
  '南翔小笼包': {
    name: '南翔小笼包',
    nameEn: 'Nanxiang Xiaolongbao',
    description: '南翔小笼包是上海最著名的传统点心，皮薄馅大，汤汁鲜美。正宗的小笼包"放在蒸笼里像座钟，夹起来像灯笼，咬开来有汤水"。',
    history: '南翔小笼包起源于上海嘉定南翔镇，清代同治年间由南翔镇日华轩点心店主黄明贤创制。后来传入上海市区，成为上海的标志性美食。',
    ingredients: ['精选面粉', '猪皮冻', '五花肉馅', '蟹粉', '生姜', '料酒'],
    taste: '皮薄馅大，汤汁鲜美，肉质鲜嫩，蟹粉香浓',
    priceRange: '¥38 - ¥168/笼',
    recommendedRestaurants: ['南翔馒头店', '鼎泰丰', '老盛昌', '佳家汤包'],
    funFacts: [
      '正宗的南翔小笼包有14个以上的褶皱',
      '汤汁来自猪皮冻蒸熟后的融化',
      '吃的时候要先咬个小口吸出汤汁',
      '蟹粉小笼是豪华版'
    ],
    category: '点心',
    popularity: 96,
    tags: ['上海特色', '传统点心', '蟹粉']
  },
  
  '生煎包': {
    name: '生煎包',
    nameEn: 'Shengjianbao',
    description: '生煎包是上海最受欢迎的街头小吃，包子底部煎得金黄酥脆，上面松软，内馅多汁。"皮薄不破又不焦，二分酵头靠烘烤，鲜馅汤汁满口来，底厚焦枯是败品"是老上海对生煎的评价。',
    history: '生煎包起源于20世纪20年代的上海，最初是茶馆的"点心"，后来逐渐独立成为专门的小吃。',
    ingredients: ['发酵面团', '五花肉馅', '皮冻', '葱花', '芝麻', '香油'],
    taste: '底部酥脆，面皮松软，肉馅鲜美，汤汁浓郁',
    priceRange: '¥18 - ¥48/份',
    recommendedRestaurants: ['小杨生煎', '大壶春', '丰裕生煎', '舒蔡记'],
    funFacts: [
      '上海有两大流派：清水派和发面派',
      '生煎包要趁热吃才够味',
      '小杨生煎是清水派的代表',
      '吃的时候要小心烫口'
    ],
    category: '小吃',
    popularity: 93,
    tags: ['上海小吃', '街头美食', '早餐']
  },
  
  '红烧肉': {
    name: '红烧肉',
    nameEn: 'Red Braised Pork',
    description: '红烧肉是本帮菜的经典代表，选用五花肉，经过慢火炖煮，成品色泽红亮，肥而不腻，入口即化。上海红烧肉讲究"浓油赤酱"，甜咸适中。',
    history: '红烧肉在中国各地都有不同版本，上海本帮红烧肉以甜咸适中、色泽红亮著称。据说苏东坡是红烧肉的最早推广者。',
    ingredients: ['五花肉', '冰糖', '料酒', '老抽', '生抽', '八角', '桂皮', '姜片'],
    taste: '肥而不腻，入口即化，甜咸适中，酱香浓郁',
    priceRange: '¥68 - ¥188/份',
    recommendedRestaurants: ['老正兴', '德兴馆', '绿波廊', '上海老站'],
    funFacts: [
      '苏东坡的《猪肉颂》是最早的红烧肉菜谱',
      '上海红烧肉要放冰糖炒糖色',
      '正宗的做法要慢炖2小时以上',
      '好的红烧肉要"走油"才不腻'
    ],
    category: '肉类',
    popularity: 91,
    tags: ['本帮菜', '传统名菜', '家常菜']
  },
  
  '糖醋排骨': {
    name: '糖醋排骨',
    nameEn: 'Sweet and Sour Spareribs',
    description: '糖醋排骨是上海本帮菜的经典冷菜，选用猪小排，经过炸制后用糖醋汁烧制，色泽红亮，酸甜适中，外酥里嫩。',
    history: '糖醋排骨是中国传统名菜，各地都有不同版本。上海版的糖醋排骨酸甜比例恰到好处，是凉菜中的经典。',
    ingredients: ['猪小排', '米醋', '白糖', '番茄酱', '料酒', '姜片', '葱花'],
    taste: '酸甜适中，外酥里嫩，色泽红亮，开胃爽口',
    priceRange: '¥48 - ¥128/份',
    recommendedRestaurants: ['老正兴', '德兴馆', '王宝和'],
    funFacts: [
      '糖醋排骨是上海人过年必备的冷菜',
      '酸甜比例是每家店的秘密',
      '可以冷吃也可以热吃',
      '番茄酱是后来才加入的'
    ],
    category: '肉类',
    popularity: 88,
    tags: ['本帮菜', '冷菜', '酸甜口味']
  },
  
  '四川火锅': {
    name: '四川火锅',
    nameEn: 'Sichuan Hotpot',
    description: '四川火锅是成都最具代表性的美食，以麻辣鲜香著称。红汤锅底用牛油、辣椒、花椒等数十种香料精心熬制，麻辣鲜香，回味无穷。',
    history: '四川火锅起源于清代道光年间，最初是重庆嘉陵江畔的船工和纤夫发明的简易吃法。后来传入成都，演变为精致的火锅文化。',
    ingredients: ['牛油', '辣椒', '花椒', '豆瓣', '香料', '毛肚', '黄喉', '鸭肠', '肥牛'],
    taste: '麻辣鲜香，层次丰富，越煮越香，欲罢不能',
    priceRange: '¥88 - ¥398/人',
    recommendedRestaurants: ['海底捞', '大龙燚', '小龙坎', '蜀大侠'],
    funFacts: [
      '成都被联合国教科文组织评为"美食之都"',
      '四川火锅的辣椒来自重庆和贵州',
      '毛肚要"七上八下"才够嫩',
      '鸳鸯锅是成都火锅的创新'
    ],
    category: '火锅',
    popularity: 99,
    tags: ['成都特色', '麻辣', '社交美食']
  },
  
  '麻婆豆腐': {
    name: '麻婆豆腐',
    nameEn: 'Mapo Tofu',
    description: '麻婆豆腐是川菜的经典代表，由陈麻婆在清代创制。豆腐嫩滑，牛肉末香酥，麻辣鲜香烫，色香味俱全。',
    history: '麻婆豆腐起源于清代同治年间，由成都万福桥的陈麻婆创制。因为她脸上有麻子，人们称她为陈麻婆，她做的豆腐就叫麻婆豆腐。',
    ingredients: ['嫩豆腐', '牛肉末', '郫县豆瓣', '花椒粉', '辣椒面', '葱花', '蒜末'],
    taste: '麻辣鲜香烫，豆腐嫩滑，牛肉香酥',
    priceRange: '¥28 - ¥88/份',
    recommendedRestaurants: ['陈麻婆豆腐', '蜀大侠', '红杏酒家'],
    funFacts: [
      '由一位脸上有麻子的老婆婆发明',
      '正宗的麻婆豆腐要用牛肉末',
      '要趁热吃才够麻够辣',
      '是最受欢迎的川菜之一'
    ],
    category: '豆腐',
    popularity: 97,
    tags: ['川菜经典', '麻辣', '家常菜']
  },
  
  '夫妻肺片': {
    name: '夫妻肺片',
    nameEn: 'Fuqi Feipian',
    description: '夫妻肺片是成都著名的凉菜，由郭朝华、张田政夫妻创制。选用牛头皮、牛心、牛舌等牛杂，配以特制的红油调料，麻辣鲜香。',
    history: '夫妻肺片起源于20世纪30年代，成都人郭朝华、张田政夫妻在街头摆摊卖凉拌牛杂。因为价格便宜，味道鲜美，深受欢迎。',
    ingredients: ['牛头皮', '牛心', '牛舌', '牛肚', '红油', '花椒粉', '芝麻', '香菜'],
    taste: '麻辣鲜香，口感丰富，回味悠长',
    priceRange: '¥38 - ¥98/份',
    recommendedRestaurants: ['夫妻肺片总店', '钟宇鸡杂', '廖记棒棒鸡'],
    funFacts: [
      '名字里的"夫妻"是指创制这道菜的郭氏夫妇',
      '其实并没有肺片，主要是牛杂',
      '最初是挑担叫卖的街头小吃',
      '现在是成都最著名的凉菜之一'
    ],
    category: '凉菜',
    popularity: 94,
    tags: ['成都特色', '凉菜', '夫妻店']
  },
  
  '担担面': {
    name: '担担面',
    nameEn: 'Dandan Noodles',
    description: '担担面是四川著名的传统面食，因最初是挑担叫卖而得名。面条细滑，调料麻辣鲜香，花生碎香酥，是成都最受欢迎的面食之一。',
    history: '担担面起源于清代，由自贡小贩陈包包创制，因为是挑担沿街叫卖，所以称为担担面。后来传入成都，成为四川标志性美食。',
    ingredients: ['手工细面', '芝麻酱', '辣椒油', '花椒粉', '花生碎', '葱花', '芽菜'],
    taste: '麻辣鲜香，面条细滑，花生香脆',
    priceRange: '¥18 - ¥48/碗',
    recommendedRestaurants: ['陈麻婆豆腐', '龙抄手', '钟水饺'],
    funFacts: [
      '因挑担沿街叫卖而得名',
      '自贡是担担面的发源地',
      '芝麻酱是担担面的灵魂',
      '可以做汤面也可以做干捞'
    ],
    category: '面食',
    popularity: 93,
    tags: ['四川面食', '传统小吃', '麻辣']
  },
  
  '早茶点心': {
    name: '早茶点心',
    nameEn: 'Cantonese Dim Sum',
    description: '广东早茶是广州最具代表性的饮食文化，"一盅两件"是广州人的生活方式。点心种类繁多，制作精美，虾饺、烧卖、肠粉是最经典的"粤式三点心"。',
    history: '广东早茶的历史可以追溯到清代咸丰年间，当时的"一厘馆"就是早茶的雏形。后来逐渐发展为茶楼，形成了"叹茶"的文化传统。',
    ingredients: ['鲜虾', '猪肉', '澄粉', '糯米', '叉烧', '椰浆', '红茶'],
    taste: '种类丰富，口味多样，精致美味',
    priceRange: '¥68 - ¥298/人',
    recommendedRestaurants: ['陶陶居', '莲香楼', '广州酒家', '点都德'],
    funFacts: [
      '"一盅两件"是广州人的生活哲学',
      '虾饺要有12个褶皱才算正宗',
      '早茶可以从早上吃到下午',
      '广州有"叹早茶"的说法'
    ],
    category: '点心',
    popularity: 97,
    tags: ['广州特色', '饮食文化', '精致点心']
  },
  
  '白切鸡': {
    name: '白切鸡',
    nameEn: 'White Cut Chicken',
    description: '白切鸡是广州最经典的家常菜，选用清远鸡，以清水浸煮，保留鸡肉的原汁原味。皮爽肉滑，配以姜葱蘸料，鲜美无比。',
    history: '白切鸡是广东传统名菜，最早可追溯到清代。"无鸡不成宴"是广东人的饮食习惯，白切鸡是宴席必备菜品。',
    ingredients: ['清远鸡', '姜', '葱', '生抽', '花生油', '冰水'],
    taste: '皮爽肉滑，原汁原味，姜葱提香',
    priceRange: '¥68 - ¥188/只',
    recommendedRestaurants: ['广州酒家', '莲香楼', '陶陶居', '侨美食家'],
    funFacts: [
      '广东人"无鸡不成宴"',
      '最好用清远鸡或文昌鸡',
      '浸煮后要过冰水让皮更爽',
      '姜葱蘸料是关键'
    ],
    category: '肉类',
    popularity: 95,
    tags: ['粤菜经典', '家常菜', '原汁原味']
  },
  
  '肠粉': {
    name: '肠粉',
    nameEn: 'Cheong Fun / Rice Noodle Roll',
    description: '肠粉是广州最受欢迎的早餐点心，用米浆蒸制成薄皮，包裹虾仁、牛肉、叉烧等馅料，配以特制酱油，滑嫩可口。',
    history: '肠粉起源于清代末期，由广州泮塘的荷香馆创制。最初是用竹篮蒸制，后来发展为抽屉式蒸炉，成为广州早餐的代表。',
    ingredients: ['米浆', '鲜虾', '牛肉', '叉烧', '葱花', '特制酱油', '花生油'],
    taste: '滑嫩可口，馅料鲜美，酱油提香',
    priceRange: '¥18 - ¥48/份',
    recommendedRestaurants: ['银记肠粉', '华辉拉肠', '源记肠粉'],
    funFacts: [
      '肠粉又称"拉肠"',
      '广州人早餐的首选',
      '抽屉式蒸炉是广州肠粉的特色',
      '可以做甜的也可以做咸的'
    ],
    category: '点心',
    popularity: 94,
    tags: ['广州早餐', '街头小吃', '滑嫩']
  },
  
  '虾饺': {
    name: '虾饺',
    nameEn: 'Har Gow',
    description: '虾饺是广东早茶"四大天王"之首，用澄粉做皮，包裹整只鲜虾，蒸熟后呈半透明状，可以看到里面的虾仁，皮薄馅大，鲜美无比。',
    history: '虾饺起源于20世纪20年代的广州五凤村，由茶楼厨师创制。因为外形像弯梳，也叫"弯梳饺"。',
    ingredients: ['澄粉', '木薯淀粉', '整只鲜虾', '猪肥膘', '笋丁', '猪油'],
    taste: '皮薄馅大，虾仁鲜美，口感爽弹',
    priceRange: '¥38 - ¥128/笼',
    recommendedRestaurants: ['广州酒家', '陶陶居', '莲香楼', '点都德'],
    funFacts: [
      '早茶"四大天王"之首',
      '正宗的虾饺要有12个以上的褶皱',
      '用澄粉做皮才能呈半透明',
      '要包裹整只鲜虾'
    ],
    category: '点心',
    popularity: 96,
    tags: ['早茶必点', '精致点心', '鲜虾']
  },
  
  '寿司': {
    name: '寿司',
    nameEn: 'Sushi',
    description: '寿司是日本最具代表性的传统美食，由醋饭和各种新鲜食材组成。江户前寿司是东京的代表，讲究食材新鲜和师傅的技艺。',
    history: '寿司起源于东南亚的发酵鱼肉保存方法，传入日本后逐渐演变。江户时代，寿司成为东京街头的快餐，发展为现在的握寿司。',
    ingredients: ['日本米', '米醋', '新鲜海鱼', '海胆', '金枪鱼', '三文鱼', '虾', '芥末', '酱油'],
    taste: '米饭微酸，鱼肉鲜美，口感丰富',
    priceRange: '¥1,000 - ¥30,000+日元/人',
    recommendedRestaurants: ['数寄屋桥次郎', '鮨さいとう', '寿司大', '大和寿司'],
    funFacts: [
      '东京有212家米其林三星餐厅，是全球最多的城市',
      '寿司之神小野二郎的店需要提前1个月预约',
      '正宗的江户前寿司要在30秒内吃完',
      '醋饭的温度要和人体体温相近'
    ],
    category: '寿司',
    popularity: 99,
    tags: ['日本美食', '传统料理', '米其林']
  },
  
  '拉面': {
    name: '拉面',
    nameEn: 'Ramen',
    description: '拉面是日本最受欢迎的国民美食，起源于中国，传入日本后发展出独特的风格。东京拉面以酱油汤底为代表，博多拉面以浓郁的猪骨汤底闻名。',
    history: '拉面在19世纪末由中国传入日本，最初是横滨中华街的中华料理。二战后，拉面逐渐成为日本国民美食，发展出各种地方特色。',
    ingredients: ['手工面条', '猪骨', '鸡骨', '酱油', '味噌', '叉烧', '笋干', '海苔', '溏心蛋'],
    taste: '汤底浓郁，面条劲道，配料丰富',
    priceRange: '¥800 - ¥2,500日元/碗',
    recommendedRestaurants: ['一兰拉面', '竹末', '斑鸠', '风神'],
    funFacts: [
      '拉面是日本人最喜欢的食物之一',
      '一兰拉面的单人隔间是特色',
      '博多拉面的汤底要熬8小时以上',
      '日本有专门的拉面博物馆'
    ],
    category: '面食',
    popularity: 97,
    tags: ['日本国民美食', '地方特色', '浓郁汤底']
  },
  
  '天妇罗': {
    name: '天妇罗',
    nameEn: 'Tempura',
    description: '天妇罗是日本传统炸物料理，将海鲜和蔬菜裹上薄面糊，用低温油炸，保持食材的原汁原味。"脆而不油"是天妇罗的最高境界。',
    history: '天妇罗起源于葡萄牙传教士带来的油炸料理，传入日本后发展为独特的日式炸物料理。江户时代，天妇罗成为平民美食。',
    ingredients: ['新鲜海虾', '鱿鱼', '茄子', '南瓜', '紫苏叶', '面粉', '冰水', '蘸料'],
    taste: '外酥里嫩，食材鲜甜，蘸料提味',
    priceRange: '¥3,000 - ¥15,000日元/人',
    recommendedRestaurants: ['天ぷらてんか', '天ぷらみかわ', '美川是山居'],
    funFacts: [
      '天妇罗起源于葡萄牙传教士',
      '面糊要用冰水和才能更酥脆',
      '油温控制在160-170°C',
      '早乙女哲哉是日本天妇罗之神'
    ],
    category: '炸物',
    popularity: 92,
    tags: ['日本传统料理', '炸物', '精致料理']
  },
  
  '和牛料理': {
    name: '和牛料理',
    nameEn: 'Wagyu Cuisine',
    description: '和牛是日本顶级牛肉的代表，以神户牛、松阪牛、近江牛"三大和牛"最为著名。和牛肉质鲜嫩，脂肪分布均匀如大理石纹，入口即化。',
    history: '和牛的培育始于19世纪后期，通过引进西方牛种与日本本土牛杂交培育而成。神户牛在19世纪末的博览会上首次获得国际认可。',
    ingredients: ['神户牛', '松阪牛', '近江牛', '铁板烧', '寿喜烧', '涮涮锅'],
    taste: '肉质鲜嫩，脂肪分布均匀，入口即化',
    priceRange: '¥5,000 - ¥50,000+日元/人',
    recommendedRestaurants: ['Narisawa', 'Quintessence', '神户牛肉专门店'],
    funFacts: [
      '神户牛曾是贡品，只有贵族才能享用',
      '和牛的大理石纹路叫"霜降"',
      '寿喜烧是和牛最经典的吃法',
      '等级最高的和牛是A5级'
    ],
    category: '肉类',
    popularity: 96,
    tags: ['顶级美食', '和牛', '精致料理']
  },
  
  '法式蜗牛': {
    name: '法式蜗牛',
    nameEn: 'French Escargot',
    description: '法式蜗牛是法国最著名的前菜之一，选用食用蜗牛，配以黄油、大蒜、欧芹等调料烤制，香气扑鼻，口感丰富。',
    history: '食用蜗牛的历史可以追溯到古罗马时期。中世纪时，法国修道院的修士开始食用蜗牛。19世纪时，蜗牛成为法国菜的经典前菜。',
    ingredients: ['食用蜗牛', '黄油', '大蒜', '欧芹', '白葡萄酒', '百里香', '面包'],
    taste: '黄油香浓，蒜香四溢，蜗牛肉弹嫩',
    priceRange: '€25 - €60/份',
    recommendedRestaurants: ['Ladurée', 'Le Jules Verne', 'Taillevent'],
    funFacts: [
      '古罗马人就开始食用蜗牛',
      '法国每年消耗约3万吨蜗牛',
      '要用专门的蜗牛夹和蜗牛叉食用',
      '配法棍面包蘸黄油是经典吃法'
    ],
    category: '前菜',
    popularity: 95,
    tags: ['法国经典', '精致前菜', '传统美食']
  },
  
  '鹅肝酱': {
    name: '鹅肝酱',
    nameEn: 'Foie Gras',
    description: '鹅肝酱是法国最顶级的美食之一，由鸭或鹅的脂肪肝制成，口感细腻如丝，入口即化，带有浓郁的香气。',
    history: '鹅肝的食用历史可以追溯到古埃及时期。罗马人将鹅肝配以无花果食用。传入法国后，发展为精致的法式料理。',
    ingredients: ['鸭肝或鹅肝', '波特酒', '白兰地', '香料', '黄油', '面包'],
    taste: '口感细腻如丝，入口即化，香气浓郁',
    priceRange: '€50 - €200+/份',
    recommendedRestaurants: ['Alain Ducasse au Plaza Athénée', 'Pierre Gagnaire', 'Arpège'],
    funFacts: [
      '古埃及人就开始食用鹅肝',
      '法国鹅肝酱被列为世界文化遗产候选',
      '可以冷吃也可以热吃',
      '配甜酒是经典搭配'
    ],
    category: '精致料理',
    popularity: 97,
    tags: ['法国顶级美食', '精致料理', '世界非遗候选']
  },
  
  '可颂面包': {
    name: '可颂面包',
    nameEn: 'Croissant',
    description: '可颂面包是法国最著名的面点，外层金黄酥脆，内部层次分明，黄油香气浓郁。正宗的可颂需要经过多次折叠和黄油夹层，形成完美的千层结构。',
    history: '可颂面包虽然是法国的代表，但据说起源于奥地利维也纳。19世纪传入法国后，经过法国面包师的改良，成为现在的可颂面包。',
    ingredients: ['高筋面粉', '黄油', '酵母', '糖', '盐', '牛奶'],
    taste: '外酥里软，层次分明，黄油香浓',
    priceRange: '€1.50 - €5/个',
    recommendedRestaurants: ['Ladurée', 'Pierre Hermé', 'Du Pain et des Idées', 'Blé Sucré'],
    funFacts: [
      '据说起源于奥地利维也纳',
      '正宗的可颂要有完美的蜂窝组织',
      '需要经过3次折叠，共27层',
      '最好在刚出炉时吃'
    ],
    category: '面包',
    popularity: 94,
    tags: ['法国早餐', '精致面点', '黄油香']
  },
  
  '马卡龙': {
    name: '马卡龙',
    nameEn: 'Macaron',
    description: '马卡龙是法国最著名的甜点，由杏仁粉和蛋白霜制成的小圆饼，中间夹有各种口味的夹心。外壳酥脆，内里软糯，口感丰富。',
    history: '马卡龙的历史可以追溯到16世纪，由意大利Catherine de Medici王后带入法国。19世纪时，巴黎糕点师Pierre Desfontaines创立了现在的马卡龙样式。',
    ingredients: ['杏仁粉', '蛋白', '糖粉', '细砂糖', '夹心奶油', '食用色素'],
    taste: '外壳酥脆，内里软糯，夹心香甜',
    priceRange: '€2 - €4/个',
    recommendedRestaurants: ['Ladurée', 'Pierre Hermé', 'Pierre Marcolini', 'Angelina'],
    funFacts: [
      '由意大利王后Catherine de Medici带入法国',
      'Ladurée是马卡龙的代名词',
      'Pierre Hermé被称为"糕点界的毕加索"',
      '完美的马卡龙要有"裙边"'
    ],
    category: '甜点',
    popularity: 96,
    tags: ['法国甜点', '精致糕点', '巴黎味道']
  },
  
  '纽约风格披萨': {
    name: '纽约风格披萨',
    nameEn: 'New York Style Pizza',
    description: '纽约风格披萨是美国最受欢迎的披萨，特点是超大的尺寸和薄而有韧性的饼底，可以折叠着吃。番茄酱和马苏里拉奶酪是经典配料。',
    history: '纽约披萨起源于1905年，意大利移民Gennaro Lombardi在纽约小意大利开设了第一家披萨店。经过美国人的改良，发展为独特的纽约风格。',
    ingredients: ['高筋面粉', '番茄酱', '马苏里拉奶酪', '橄榄油', '酵母', '各种配料'],
    taste: '饼底薄而有韧性，奶酪拉丝，番茄酱香浓',
    priceRange: '$2 - $5/片，$18 - $30/整只',
    recommendedRestaurants: ["Joe's Pizza", "Di Fara Pizza", 'Lombardi\'s', "Grimaldi's"],
    funFacts: [
      '1905年，Lombardi\'s是美国第一家披萨店',
      "Joe's Pizza是《蜘蛛侠》里出现的披萨店",
      '纽约披萨要折叠着吃',
      '纽约的水据说让披萨更好吃'
    ],
    category: '披萨',
    popularity: 96,
    tags: ['纽约特色', '美国经典', '街头美食']
  },
  
  '汉堡': {
    name: '汉堡',
    nameEn: 'Hamburger',
    description: '汉堡是美国最具代表性的快餐食品，由两片面包夹着牛肉饼、生菜、番茄、奶酪、酸黄瓜等配料组成。高品质的汉堡讲究牛肉的品质和烹饪方式。',
    history: '汉堡的名字来源于德国汉堡市，但现代汉堡是在美国发展起来的。1904年圣路易斯世博会上，汉堡首次亮相，后来成为美国国民美食。',
    ingredients: ['牛肉饼', '汉堡面包', '生菜', '番茄', '奶酪', '酸黄瓜', '洋葱', '酱汁'],
    taste: '牛肉多汁，面包松软，配料新鲜',
    priceRange: '$5 - $25/个',
    recommendedRestaurants: ['Shake Shack', "Five Guys", 'In-N-Out Burger', "Peter Luger's"],
    funFacts: [
      '名字来自德国汉堡市',
      '美国人每年消耗约500亿个汉堡',
      'Shake Shack起源于麦迪逊广场花园的热狗摊',
      'In-N-Out Burger只有4种配料'
    ],
    category: '快餐',
    popularity: 95,
    tags: ['美国国民美食', '快餐经典', '牛肉']
  },
  
  '热狗': {
    name: '热狗',
    nameEn: 'Hot Dog',
    description: '热狗是美国最经典的街头食品，由香肠夹在长条形面包中，配以芥末、番茄酱、酸黄瓜、酸菜等调料。是棒球比赛和街头小吃的代表。',
    history: '热狗起源于德国法兰克福香肠，传入美国后发展为热狗。1904年圣路易斯世博会上，热狗首次用长面包夹着卖。',
    ingredients: ['法兰克福香肠', '热狗面包', '芥末', '番茄酱', '酸黄瓜', '酸菜', '洋葱'],
    taste: '香肠多汁，面包松软，调料提味',
    priceRange: '$3 - $10/个',
    recommendedRestaurants: ['Nathan\'s Famous', "Gray's Papaya", "Papaya King", 'Shake Shack'],
    funFacts: [
      'Nathan\'s每年举办吃热狗大赛',
      '美国人每年消耗约200亿个热狗',
      '热狗面包是为了方便食用发明的',
      '是棒球比赛的经典食物'
    ],
    category: '快餐',
    popularity: 93,
    tags: ['美国街头美食', '棒球经典', '快餐']
  },
  
  '贝果': {
    name: '贝果',
    nameEn: 'Bagel',
    description: '贝果是纽约最具代表性的早餐食品，源于犹太社区。贝果面团要先煮后烤，形成独特的韧性口感和金黄外皮。配奶油奶酪是经典吃法。',
    history: '贝果起源于波兰犹太社区，19世纪末随着东欧犹太移民传入纽约。逐渐成为纽约早餐的代表，发展出各种口味。',
    ingredients: ['高筋面粉', '酵母', '糖', '盐', '麦芽精', '奶油奶酪', '烟熏三文鱼', '红洋葱'],
    taste: '口感韧性，外皮金黄，内芯松软',
    priceRange: '$2 - $6/个，配奶油奶酪+$3',
    recommendedRestaurants: ['Ess-a-Bagel', 'Russ & Daughters', 'H&H Bagels', "Murray's Bagels"],
    funFacts: [
      '贝果要先煮后烤才有韧性',
      '源于波兰犹太社区',
      'Russ & Daughters是纽约百年老店',
      "Everything Bagel是最受欢迎的口味"
    ],
    category: '面包',
    popularity: 92,
    tags: ['纽约早餐', '犹太美食', '奶油奶酪']
  },
  
  '章鱼烧': {
    name: '章鱼烧',
    nameEn: 'Takoyaki',
    description: '章鱼烧是大阪最著名的街头小吃，由面糊、章鱼块、包菜、姜等制成的小圆球，烤至金黄，配以照烧酱、美乃滋、海苔粉和木鱼花。',
    history: '章鱼烧起源于1935年的大阪，由路边摊贩远藤留吉创制。最初是用牛筋制作，后来改用章鱼，成为大阪的标志性美食。',
    ingredients: ['章鱼块', '面糊', '包菜', '红姜', '照烧酱', '美乃滋', '海苔粉', '木鱼花'],
    taste: '外酥里嫩，章鱼弹牙，酱料香浓',
    priceRange: '¥300 - ¥800日元/份（6-8个）',
    recommendedRestaurants: ['たこ昌', 'たこ家道頓堀', '甲賀流', '会津屋'],
    funFacts: [
      '1935年由大阪摊贩远藤留吉发明',
      '用专门的圆形模具烤制',
      '道顿堀是章鱼烧的发源地',
      '要趁热吃，小心烫口'
    ],
    category: '街头小吃',
    popularity: 92,
    tags: ['大阪特色', '街头美食', '章鱼']
  },
  
  '大阪烧': {
    name: '大阪烧',
    nameEn: 'Okonomiyaki',
    description: '大阪烧是大阪的"日式披萨"，由面糊、包菜、猪肉、虾等食材混合后在铁板上煎制，配以照烧酱、美乃滋、海苔粉和木鱼花。',
    history: '大阪烧的历史可以追溯到明治时代，最初是简单的面饼。战后发展为现在的样式，"お好み焼き"的意思是"随你喜欢烤"。',
    ingredients: ['面糊', '包菜', '猪肉', '虾', '鱿鱼', '鸡蛋', '照烧酱', '美乃滋'],
    taste: '外酥里嫩，食材丰富，酱料香浓',
    priceRange: '¥800 - ¥2,000日元/份',
    recommendedRestaurants: ['千房', 'たけむら', 'お好み焼き もんじゃ', '波平'],
    funFacts: [
      '"お好み焼き"意思是"随你喜欢烤"',
      '关西风格和广岛风格不同',
      '广岛风格会加炒面',
      '可以自己在铁板上烤'
    ],
    category: '铁板料理',
    popularity: 90,
    tags: ['大阪特色', '铁板料理', '日式披萨']
  },
  
  '韩式烤肉': {
    name: '韩式烤肉',
    nameEn: 'Korean BBQ',
    description: '韩式烤肉是韩国最具代表性的美食，在餐桌上用炭火或燃气烤炉烤制各种肉类，配以生菜、泡菜、蘸酱食用。五花肉和牛小排是最受欢迎的部位。',
    history: '韩式烤肉的历史可以追溯到高句丽时期，当时已有"炙"的烹饪方式。现代韩式烤肉在20世纪后期发展为现在的形式，风靡全球。',
    ingredients: ['五花肉', '牛小排', '牛舌', '生菜', '泡菜', '大蒜', '蘸酱', '烧酒'],
    taste: '烤肉香嫩，生菜解腻，蘸酱提味',
    priceRange: '₩15,000 - ₩50,000韩元/人',
    recommendedRestaurants: ['本家', '王妃家', '姜虎东白丁', '河东馆'],
    funFacts: [
      '历史可追溯到高句丽时期',
      '要用生菜包着吃',
      '烤牛舌是高端选择',
      '配韩国烧酒是经典搭配'
    ],
    category: '烤肉',
    popularity: 94,
    tags: ['韩国特色', '社交美食', '炭火烤肉']
  },
  
  '炸鸡啤酒': {
    name: '炸鸡啤酒',
    nameEn: 'Chimaek',
    description: '炸鸡配啤酒是韩国最流行的夜生活美食，"치맥(Chimaek)"是炸鸡(치킨)和啤酒(맥주)的合成词。韩国炸鸡有酱油、蒜香、辣味等多种口味。',
    history: '炸鸡在1980年代随着韩国经济起飞开始流行。2002年世界杯期间，炸鸡配啤酒成为全民热潮，发展为韩国独特的饮食文化。',
    ingredients: ['鸡肉', '面粉', '各种调味酱', '韩国啤酒', '腌萝卜'],
    taste: '外酥里嫩，口味多样，啤酒解腻',
    priceRange: '₩15,000 - ₩30,000韩元/只',
    recommendedRestaurants: ['校村炸鸡', 'BBQ炸鸡', 'BHC炸鸡', 'Kyochon'],
    funFacts: [
      '"Chimaek"是韩国发明的合成词',
      '2002年世界杯后开始流行',
      '韩国每年消耗约10亿只炸鸡',
      '配腌萝卜是经典吃法'
    ],
    category: '炸鸡',
    popularity: 95,
    tags: ['韩流美食', '夜生活', 'Chimaek']
  },
  
  '冬阴功汤': {
    name: '冬阴功汤',
    nameEn: 'Tom Yum Goong',
    description: '冬阴功汤是泰国最著名的传统汤品，"冬阴"是酸辣的意思，"功"是虾的意思。用香茅、南姜、柠檬叶、辣椒等香料熬制，酸辣开胃，香气浓郁。',
    history: '冬阴功汤是泰国中部的传统汤品，历史悠久。是泰国国菜，也是东南亚最著名的美食之一。',
    ingredients: ['大虾', '香茅', '南姜', '柠檬叶', '小米辣', '鱼露', '柠檬汁', '草菇'],
    taste: '酸辣开胃，香气浓郁，虾鲜肉嫩',
    priceRange: '฿80 - ฿300泰铢/份',
    recommendedRestaurants: ['Thip Samai', 'Som Tam Nua', 'Savoey Thai Restaurant', 'Café de Nara'],
    funFacts: [
      '"冬阴"是酸辣，"功"是虾',
      '是泰国的国汤',
      '可以做清汤也可以加椰奶',
      '香茅、南姜、柠檬叶是三大香料'
    ],
    category: '汤品',
    popularity: 94,
    tags: ['泰国国汤', '酸辣开胃', '经典泰菜']
  },
  
  '芒果糯米饭': {
    name: '芒果糯米饭',
    nameEn: 'Mango Sticky Rice',
    description: '芒果糯米饭是泰国最著名的甜点，用椰浆浸泡的糯米搭配新鲜芒果，再淋上椰浆和芝麻。甜香软糯，是热带水果与糯米的完美结合。',
    history: '芒果糯米饭起源于泰国东北部，是当地传统甜点。后来传遍全国，成为泰国最受欢迎的甜点之一。',
    ingredients: ['糯米', '新鲜芒果', '椰浆', '棕榈糖', '盐', '芝麻'],
    taste: '糯米软糯，芒果香甜，椰香浓醇',
    priceRange: '฿60 - ฿150泰铢/份',
    recommendedRestaurants: ['Mae Varee', 'Kor Panich', 'Taling Pling', 'Savoey Thai Restaurant'],
    funFacts: [
      '起源于泰国东北部',
      '最好的季节是芒果成熟的夏季',
      '糯米要用泰国香糯米',
      '可以热吃也可以冷吃'
    ],
    category: '甜点',
    popularity: 93,
    tags: ['泰国甜点', '热带美食', '芒果']
  },
  
  '海南鸡饭': {
    name: '海南鸡饭',
    nameEn: 'Hainanese Chicken Rice',
    description: '海南鸡饭是新加坡的国菜，起源于中国海南。用鸡汤煮熟的白切鸡，配以用鸡油和鸡汤煮的米饭，再配以辣椒酱和姜末酱油。',
    history: '海南鸡饭起源于中国海南省，19世纪末由海南移民传入新加坡和马来西亚。经过改良发展为现在的样式，成为新加坡的国民美食。',
    ingredients: ['海南鸡', '泰国香米', '鸡油', '鸡汤', '辣椒酱', '姜末酱油', '黄瓜'],
    taste: '鸡肉鲜嫩，米饭香滑，辣椒酱提味',
    priceRange: 'S$3 - S$8/份',
    recommendedRestaurants: ['天天海南鸡饭', '威南记', '津津餐室', '新瑞记'],
    funFacts: [
      '被称为新加坡的国菜',
      '起源于中国海南省',
      '天天海南鸡饭是米其林推荐',
      '米饭要用鸡油炒过再煮'
    ],
    category: '主食',
    popularity: 91,
    tags: ['新加坡国菜', '海南特色', '国民美食']
  },
  
  '辣椒螃蟹': {
    name: '辣椒螃蟹',
    nameEn: 'Chili Crab',
    description: '辣椒螃蟹是新加坡最著名的海鲜菜，用新鲜的螃蟹配以番茄和辣椒调制的酱汁，酸甜微辣，香气浓郁。配炸馒头蘸酱汁是经典吃法。',
    history: '辣椒螃蟹起源于20世纪50年代的新加坡，由大排档摊主首创。后来经过不断改良，成为新加坡的标志性美食。',
    ingredients: ['新鲜螃蟹', '番茄酱', '辣椒酱', '鸡蛋', '酸柑', '炸馒头', '香菜'],
    taste: '酸甜微辣，蟹肉鲜嫩，酱汁浓郁',
    priceRange: 'S$30 - S$80/公斤（按重量计价）',
    recommendedRestaurants: ['珍宝海鲜', '无招牌海鲜', '龙海鲜螃蟹王', '棕榈滩海鲜'],
    funFacts: [
      '被称为新加坡的国菜',
      '起源于20世纪50年代的大排档',
      '要用炸馒头蘸酱汁吃',
      '珍宝海鲜是最著名的连锁店'
    ],
    category: '海鲜',
    popularity: 90,
    tags: ['新加坡国菜', '海鲜', '招牌菜']
  },
  
  '炸鱼薯条': {
    name: '炸鱼薯条',
    nameEn: 'Fish and Chips',
    description: '炸鱼薯条是英国最著名的传统美食，用新鲜的鳕鱼或黑线鳕裹上面糊油炸，配以厚切薯条和盐醋。是英国工人阶级的经典美食。',
    history: '炸鱼薯条起源于19世纪中期，是犹太移民带来的炸鱼和爱尔兰的薯条的结合。1860年，Joseph Malin在伦敦开设了第一家炸鱼薯条店。',
    ingredients: ['鳕鱼或黑线鳕', '面粉', '啤酒', '土豆', '盐', '麦芽醋', '塔塔酱'],
    taste: '鱼肉鲜嫩，外皮酥脆，薯条香浓',
    priceRange: '£8 - £15/份',
    recommendedRestaurants: ['The Golden Hind', 'Fish Central', 'Kerbisher & Malt', 'Poppies Fish and Chips'],
    funFacts: [
      '1860年伦敦出现第一家炸鱼薯条店',
      '二战时是英国唯一不受配给限制的食物',
      '传统上要用报纸包着吃',
      '盐和麦芽醋是经典调料'
    ],
    category: '快餐',
    popularity: 86,
    tags: ['英国传统', '工人阶级美食', '经典英式']
  },
  
  '英式下午茶': {
    name: '英式下午茶',
    nameEn: 'Afternoon Tea',
    description: '英式下午茶是英国最优雅的饮食传统，通常在下午3-5点享用。包括三层点心架：底层是三明治，中层是司康饼配奶油和果酱，顶层是精致甜点。配以红茶。',
    history: '英式下午茶起源于19世纪中期，由贝德福德公爵夫人安娜发明。因为晚餐很晚，她下午会感到饥饿，于是让仆人准备茶点，后来发展为社交活动。',
    ingredients: ['红茶', '三明治', '司康饼', '凝脂奶油', '果酱', '精致甜点', '银质茶具'],
    taste: '优雅精致，口味多样，茶香浓郁',
    priceRange: '£25 - £80+/人',
    recommendedRestaurants: ['The Ritz', 'Fortnum & Mason', 'The Savoy', 'Bettys Tea Rooms'],
    funFacts: [
      '由贝德福德公爵夫人安娜发明',
      '司康饼要从中间掰开',
      '凝脂奶油是德文郡和康沃尔郡的特产',
      'The Ritz的下午茶需要提前预约'
    ],
    category: '茶饮',
    popularity: 88,
    tags: ['英国传统', '优雅社交', '精致甜点']
  },
  
  '意大利面': {
    name: '意大利面',
    nameEn: 'Pasta',
    description: '意大利面是意大利最具代表性的美食，种类繁多，从长的、短的、细的、宽的到空心的，每种都有最适合的酱汁。罗马的卡邦尼意面、博洛尼亚肉酱面是经典。',
    history: '意大利面的历史可以追溯到古罗马时期，当时已有"lagana"的记载。13世纪时，马可波罗从中国带回面条制作技术的传说广为流传。',
    ingredients: ['硬质小麦粉', '鸡蛋', '水', '各种酱汁', '帕玛森奶酪', '新鲜罗勒'],
    taste: '面条劲道，酱汁香浓，奶酪提味',
    priceRange: '€10 - €30/份',
    recommendedRestaurants: ['Da Enzo al 29', 'Roscioli', 'Da Francesco a Rione Monti', 'Osteria Da Fortunata'],
    funFacts: [
      '意大利有超过300种意大利面',
      '要用硬质小麦粉制作才劲道',
      '传说马可波罗从中国带回面条技术',
      '罗马人喜欢吃长面条'
    ],
    category: '面食',
    popularity: 96,
    tags: ['意大利国菜', '传统美食', '多种多样']
  },
  
  '玛格丽特披萨': {
    name: '玛格丽特披萨',
    nameEn: 'Margherita Pizza',
    description: '玛格丽特披萨是那不勒斯最经典的披萨，用番茄、马苏里拉奶酪和罗勒制作，代表意大利国旗的红白绿三色。要用木柴火炉烤制，饼底薄而有韧性。',
    history: '玛格丽特披萨起源于1889年的那不勒斯，披萨师Raffaele Esposito为玛格丽特女王创作了这款披萨，用番茄、奶酪、罗勒代表意大利国旗的颜色。',
    ingredients: ['那不勒斯面团', '圣马扎诺番茄', '马苏里拉奶酪', '新鲜罗勒', '橄榄油', '海盐'],
    taste: '饼底外酥里嫩，番茄酸甜，奶酪香浓',
    priceRange: '€8 - €20/份',
    recommendedRestaurants: ["L'Antica Pizzeria da Michele", 'Sorbillo', 'Di Matteo', 'Pizzeria Brandi'],
    funFacts: [
      '1889年为玛格丽特女王创作',
      '红白绿代表意大利国旗',
      "L'Antica Pizzeria da Michele是《美食、祈祷和恋爱》取景地",
      '那不勒斯披萨被列为世界文化遗产'
    ],
    category: '披萨',
    popularity: 97,
    tags: ['那不勒斯经典', '世界非遗', '简单美味']
  },
  
  '提拉米苏': {
    name: '提拉米苏',
    nameEn: 'Tiramisu',
    description: '提拉米苏是意大利最著名的甜点，由手指饼干、咖啡、马斯卡彭奶酪、蛋黄、糖等制成，层层叠加，口感丰富，香气浓郁。',
    history: '提拉米苏的起源有多种说法，最可信的是20世纪60年代诞生于意大利特雷维索的一家餐厅。"Tiramisu"在意大利语中是"带我走"的意思。',
    ingredients: ['马斯卡彭奶酪', '手指饼干', '浓缩咖啡', '蛋黄', '糖', '可可粉', '玛萨拉酒'],
    taste: '层次丰富，咖啡香浓，奶酪柔滑',
    priceRange: '€8 - €18/份',
    recommendedRestaurants: ['Pompi', 'Fassi', 'Pasticceria Nannini', 'Pasticceria Bruno'],
    funFacts: [
      '"Tiramisu"意思是"带我走"',
      '20世纪60年代诞生于特雷维索',
      '马斯卡彭奶酪是关键材料',
      '可以加酒也可以不加'
    ],
    category: '甜点',
    popularity: 95,
    tags: ['意大利甜点', '经典', '咖啡香浓']
  },
  
  '海鲜饭': {
    name: '海鲜饭',
    nameEn: 'Paella',
    description: '海鲜饭是西班牙最著名的国菜，起源于瓦伦西亚。用短粒米、藏红花、各种海鲜或肉类在平底锅中烹制，底部形成香脆的"锅巴"。',
    history: '海鲜饭起源于19世纪的瓦伦西亚，最初是农民在田间用平底锅烹制的简易餐食，加入兔肉、鸡肉、豆角等。后来加入海鲜，发展为现在的样式。',
    ingredients: ['短粒米', '藏红花', '海鲜（虾、鱿鱼、蛤蜊、贻贝）', '鸡肉', '青豆', '红椒', '橄榄油'],
    taste: '米饭香浓，海鲜鲜美，锅巴香脆',
    priceRange: '€15 - €40/人',
    recommendedRestaurants: ['Can Majó', 'Cal Pep', 'La Paradeta', 'El Xampanyet'],
    funFacts: [
      '起源于瓦伦西亚，不是巴塞罗那',
      '最初用兔肉和鸡肉，没有海鲜',
      '藏红花赋予米饭金黄色',
      '底部的锅巴叫"socarrat"'
    ],
    category: '米饭',
    popularity: 94,
    tags: ['西班牙国菜', '瓦伦西亚', '海鲜']
  },
  
  '塔帕斯': {
    name: '塔帕斯',
    nameEn: 'Tapas',
    description: '塔帕斯是西班牙最独特的饮食文化，不是一道菜，而是一种用餐方式。各种小份菜肴可以点多份分享，包括橄榄、火腿、炸鱿鱼圈、西班牙土豆煎蛋等。',
    history: '塔帕斯的历史可以追溯到中世纪，当时西班牙国王阿方索十世生病期间只能吃小份食物。后来发展为酒吧文化，人们在喝酒时点塔帕斯配酒。',
    ingredients: ['伊比利亚火腿', '橄榄', '炸鱿鱼圈', '西班牙土豆煎蛋', '蒜蓉虾', '青椒', '各种奶酪'],
    taste: '种类丰富，口味多样，适合分享',
    priceRange: '€3 - €10/份（每份小份）',
    recommendedRestaurants: ['Cervecería Catalana', 'Can Culleretes', 'Quimet i Quimet', 'El Xampanyet'],
    funFacts: [
      '"Tapa"在西班牙语中是"盖子"的意思',
      '传说最初是用面包盖住酒杯防苍蝇',
      '西班牙人有"塔帕斯之旅"的传统',
      '可以边走边吃边喝酒'
    ],
    category: '小吃',
    popularity: 93,
    tags: ['西班牙文化', '社交美食', '小份分享']
  }
};

export const getFoodDetail = (foodName) => {
  return foodDetails[foodName] || null;
};

export const searchFoods = (query) => {
  const lowerQuery = query.toLowerCase();
  return Object.keys(foodDetails).filter(name => 
    name.toLowerCase().includes(lowerQuery) ||
    foodDetails[name].nameEn.toLowerCase().includes(lowerQuery) ||
    foodDetails[name].tags.some(tag => tag.toLowerCase().includes(lowerQuery))
  ).map(name => foodDetails[name]);
};

export const getFoodsByCategory = (category) => {
  return Object.values(foodDetails).filter(food => food.category === category);
};

export const getPopularFoods = (limit = 10) => {
  return Object.values(foodDetails)
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
};

export const foodCategories = [
  '肉类', '海鲜', '面食', '米饭', '火锅', '寿司',
  '点心', '面包', '甜点', '汤品', '前菜', '凉菜',
  '炸物', '铁板料理', '快餐', '茶饮', '小吃', '豆腐'
];

export default foodDetails;
